import React from 'react';
import Header from './components/layout/Header';
import Hero from './components/home/Hero';  
import TimelinePreview from './components/home/TimelinePreview';  
import ValueProp from './components/home/ValueProp';
import Footer from './components/layout/Footer';
import './styles/globals.css';

function App() {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-indigo-50 via-white to-amber-50 overflow-hidden">
      {/* Global Background Pattern */}
      <div className="fixed inset-0 opacity-30 pointer-events-none">
        <div className="absolute top-20 left-10 w-2 h-2 rounded-full animate-pulse brand-dot-indigo"></div>
        <div className="absolute top-40 right-20 w-3 h-3 rounded-full animate-pulse delay-1000 brand-dot-amber"></div>
        <div className="absolute bottom-40 left-20 w-2 h-2 rounded-full animate-pulse delay-2000 brand-dot-emerald"></div>
        <div className="absolute bottom-20 right-40 w-4 h-4 rounded-full animate-pulse delay-500 brand-dot-indigo300"></div>
        <div className="absolute top-60 left-1/3 w-3 h-3 rounded-full animate-pulse delay-1500 brand-dot-pink"></div>
        <div className="absolute bottom-60 right-1/3 w-2 h-2 rounded-full animate-pulse delay-2500 brand-dot-cyan"></div>
        <div className="absolute top-1/3 right-10 w-2 h-2 rounded-full animate-pulse delay-3000 brand-dot-purple"></div>
        <div className="absolute bottom-1/3 left-1/4 w-3 h-3 rounded-full animate-pulse delay-500 brand-dot-yellow"></div>
      </div>
      {/* Content with relative positioning */}
      <div className="relative z-10">
        <Header />
        <Hero />
        <TimelinePreview />
        <ValueProp />
        <Footer />
      </div>
    </div>
  );
}

export default App;
